<template>
  <div
    class="vertical-sub-tabs-layout"
    :style="orientation === 'horizontal' ? 'flex-direction: column' : null"
  >
    <div class="tabs">
      <slot name="tabs"> </slot>
    </div>
    <div class="content">
      <slot name="content"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerticalSubTabsLayout",

  props: {
    orientation: {
      type: String,
      default: "vertical",
      validator: (value) => ["horizontal", "vertical"].includes(value),
    },
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.vertical-sub-tabs-layout {
  display: flex;
  gap: $spacing-md;

  .tabs {
    max-width: 220px;
    flex-shrink: 1;
    flex-grow: 0;
    width: 100%;
  }

  .content {
    flex-grow: 1;
    flex-shrink: 1;
  }
}
</style>
